import React, { useCallback, useContext, useEffect, useState } from 'react';
import UserContext, { PusherContext, UserProfileContext } from '../utils/getContext';
import { checkIsPartner, getUserRoles } from '../utils/memo';
import { useHistoryStore } from '../utils/router';
import { usePusher } from '../utils/pusher.utills';

const AuthExternal = ({ children, errorPage }) => {
    const { userToken, storageLoaded, setUserToken, lang, setState } = useContext(UserContext);

    const [profileData, setProfileData] = useState(false);
    const [loaded, setLoaded] = useState(!userToken && storageLoaded);
    const [roles, setRoles] = useState([]);
    const { pusherClient } = usePusher(loaded && userToken, lang);

    const updateProfileData = useCallback(
        (cache) => {
            if (!cache) {
                checkIsPartner.cache.clear();
            }
            checkIsPartner(userToken, lang).then(async (data) => {
                if (data?.data?.data) {
                    setProfileData(data?.data?.data);
                    setState('loadedProfile', true);
                    setState('profile', { country: data?.data?.data?.country, currency: data?.data?.data?.currency });
                    setLoaded(true);
                } else {
                    if (data === 401) {
                        setUserToken(false);
                    } else {
                        setLoaded(true);
                        setState('loadedProfile', true);
                    }
                }
            });
        },
        [lang, setUserToken, userToken]
    );
    useEffect(() => {
        if (storageLoaded) {
            if (userToken) {
                (async () => {
                    const { data, status } = (await getUserRoles(userToken, lang)) || {};
                    if (status === 401) {
                        setUserToken(false);
                    } else {
                        setRoles(data || []);
                        updateProfileData(true);
                    }
                })();
            } else {
                setProfileData(false);
                setRoles([]);
                setLoaded(true);
                setState('loadedProfile', true);
            }
        }
    }, [lang, setUserToken, updateProfileData, userToken, storageLoaded]);

    useHistoryStore(!errorPage, 'external');

    return (
        <>
            <PusherContext.Provider value={{ pusherClient }}>
                <UserProfileContext.Provider
                    value={{
                        profileData,
                        updateProfileData,
                        loaded,
                        mainPage: true,
                        roles
                    }}
                >
                    {children}
                </UserProfileContext.Provider>
            </PusherContext.Provider>
        </>
    );
};

export default AuthExternal;
